<template>
    <html>

    <body>
        <!--登录框-->
        <section class=" inner bg-home d-flex align-items-center" style="position: absolute;top:25%;left: 25%">
            <div class="container">
                <div class="row align-items-center inner">
                    <!--左侧图-->
                    <div class="col-lg-7 col-md-6" >
                        <div class="mr-lg-5">
                            <img :src="require('@/assets/log2.jpg')" class="img-fluid d-block mx-auto" style="left:30px" alt="">
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-6" style="position: absolute;top:60px;right:30px">
                        <div class="card login-page bg-white shadow rounded border-0">
                            <div class="card-body">
                                <h4 class="card-title text-center">用户登录</h4>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group position-relative">
                                            <label>用户名 <span class="text-danger">*</span></label>
                                            <i data-feather="user" class="fea icon-sm icons"></i>
                                            <input type="text" class="form-control pl-5" placeholder="请输入用户名"
                                                v-model="tm_username" id="tm_username" value="" />
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-group position-relative">
                                            <label>密 &nbsp; 码 <span class="text-danger">*</span></label>
                                            <i data-feather="key" class="fea icon-sm icons"></i>
                                            <input type="password" class="form-control pl-5" placeholder="请输入密码"
                                                v-model="tm_password" id="tm_password" value="" />
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mb-0">
                                        <!--登录按钮-->
                                        <button class="btn btn-primary btn-block" id="tm_btn_login" @click="Login()">登
                                            &nbsp; 录</button>
                                        <input type="hidden" name="tm_verify" id="tm_verify0" value="gj5ol" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </body>

    </html>
</template>

<script>

function dataValidation(username, password) {
    var flag = 0;
    if (username === '' || password === '') {
        alert("请输入正确的用户名密码！");
        flag = 1;
    }
    return flag;
}
export default {
    name: 'Login',
    data() {
        return {
            tm_username: '',
            tm_password: '',
        }
    },
    methods: {
        async Login() {
            //获取用户名及密码
            var username = this.tm_username;
            var password = this.tm_password;
            var flag = dataValidation(username, password);
            if (flag == 1) return;
            await this.$store.dispatch('login', {
                api: this.$apiRoot, userinfo: {
                    "username": username,
                    "password": password,
                }
            })

            this.$router.push({
                path: '/Home'
            })
        },
    },
    mounted() {
    }

}
</script>


<style>
.inner {
    /* margin: auto; */
    position: relative;
    margin: auto;
    right: 10%;
}

</style>